import { Link, useNavigate, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const Employee = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    size: 20,
    part: 1,
    mobile: "",
    firstName: "",
    lastName: "",
    code: "",
    type: 0,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    branchId: branchId,
    employeeType: 0,
    phoneNumber: "",
    password: "",
    firstname: "",
    lastname: "",
    nCode: "",
    address: "",
    gender: 0,
    avatar: ""
  });
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const navigate = useNavigate();

  const getGridData = async () => {
    const resp = await apiMethod.getEmployees(filterModel.branchId, filterModel.size, filterModel.part, filterModel.mobile, filterModel.firstName, filterModel.lastName, filterModel.code, filterModel.type);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const setStaffActivation = async (employeeId) => {
    setLoading(true);
    const resp = await apiMethod.changeActivationEmployee({
      branchId: branchId,
      employeeId: employeeId
    });

    if (methods.showApiErrors(resp))
      await getGridData();

    setLoading(false);
  }

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getEmployeeTypes();
    if (methods.showApiErrors(resp1))
      setEmployeeTypes(resp1.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      await getBaseInfo();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.firstname)) {
      errors.push('.نام باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.lastname)) {
      errors.push('.نام خانوادگی باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.nCode)) {
      errors.push('.کد‌ملی باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.phoneNumber)) {
      errors.push('.شماره موبایل باید مقدار داشته باشد');
    } else if (!methods.validatePhoneNumber(formModel.phoneNumber)) {
      errors.push('شماره موبایل وارد شده صحیح نیست');
    }
    if (methods.isNullOrEmptyString(formModel.employeeType) || formModel.employeeType === 0) {
      errors.push('. سمت شغلی باید مقدار داشته باشد');
    }
    if (formModel.id === 0 && methods.isNullOrEmptyString(formModel.password)) {
      errors.push('.رمز عبور باید مقدار داشته باشد');
    } else if (formModel.id === 0 && formModel.password.length < 6) {
      errors.push('.رمز عبور باید حداقل 6 کاراکتر داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.branchId = branchId;
    formModel.employeeType = 0;
    formModel.phoneNumber = "";
    formModel.password = "";
    formModel.firstname = "";
    formModel.lastname = "";
    formModel.nCode = "";
    formModel.address = "";
    formModel.gender = 0;
    formModel.avatar = ""
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.mobile = "";
    filterModel.firstName = "";
    filterModel.lastName = "";
    filterModel.code = 0;
    filterModel.type = 0;
    filterModel.total = 0;
    filterModel.parts = 0
    setFilterModel({ ...filterModel })
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getEmployeeInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.branchId = resp.data.branchId;
    formModel.employeeType = resp.data.employeeType;
    formModel.phoneNumber = resp.data.phoneNumber;
    formModel.password = resp.data.password;
    formModel.firstname = resp.data.firstname;
    formModel.lastname = resp.data.lastname;
    formModel.nCode = resp.data.nCode;
    formModel.address = resp.data.address;
    formModel.gender = resp.data.gender;
    formModel.avatar = resp.data.avatar;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createEmployee(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const UploadFile = async (file, attributeName) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("FileType", 1);

      // Check if the attribute name is "imgSrc" or "logo" and append the corresponding value to the FormData
      const attributeValue = formModel[attributeName];
      if (typeof attributeValue === 'string') {
        formData.append(attributeName, attributeValue);
      }
      const response = await apiMethod.uploadFile(formData);

      // Update branchData with the response data
      setFormModel((prevData) => ({
        ...prevData,
        [attributeName]: response.data,
      }));
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const changeImage = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel((prevData) => ({
      ...prevData,
      avatar: file
    }));
    setIsImageUploading(true);

    // Upload the file
    UploadFile(file, "avatar")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsImageUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const selectَItemToDelete = (employee) => {
    setFormModel(employee);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeEmployee(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/#2`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#2`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                مدیریت کارمندان
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p> مدیریت کارمندان
                <a href={`/sale/${branchId}/softwareGuide/#section6`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-2 col-lg-3'>
                    <label htmlFor="funit" className="form-label">نام</label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={filterModel.firstName}
                      onChange={(e) => { setFilterModel({ ...filterModel, firstName: e.target.value, part: 1 }) }}
                    />
                  </div>
                  <div className='col-12 col-md-2 col-lg-3'>
                    <label htmlFor="funit" className="form-label">نام‌خانوادگی</label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={filterModel.lastName}
                      onChange={(e) => { setFilterModel({ ...filterModel, lastName: e.target.value, part: 1 }) }}
                    />
                  </div>
                  <div className='col-12 col-md-2 col-lg-2'>
                    <label htmlFor="funit" className="form-label">کد پرسنلی</label>
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: 'rtl', textAlign: 'right' }}
                      value={filterModel.code}
                      onChange={(e) => { setFilterModel({ ...filterModel, code: e.target.value, part: 1 }) }}
                    />
                  </div>
                  <div className='col-12 col-md-2 col-lg-2' style={{ marginTop: '37px' }}>
                    <button type='button' className='btn btn-purple me-1'
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button type='button' className='btn btn-outline-info'
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                  <div className='col-12 col-md-4 col-lg-2'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>کارمند جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">نام</th>
                      <th scope="col vertical-center">موبایل </th>
                      <th scope="col vertical-center">کد پرسنلی </th>
                      <th scope="col vertical-center">سمت شغلی</th>
                      <th scope="col vertical-center"> نقش ها</th>
                      <th>وضعیت</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((employee, index) => (
                      <tr key={employee.id}>
                        <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                        <td>{employee.firstname} {employee.lastname}</td>
                        <td>{employee.phoneNumber}</td>
                        <td>{employee.employeeCode}</td>
                        <td>{employeeTypes.find((type) => type.id === employee.employeeType)?.title || ''}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-purple"
                            onClick={() => navigate(`/sale/${branchId}/employee/employeeRole/${employee.userId}`)}
                          >
                            مدیریت نقش‌ها
                          </button>
                        </td>
                        <td>
                          {employee.isActive &&
                            <button onClick={() => { setStaffActivation(employee.id) }} type='button' className='btn btn-success btn-sm'>
                              <i className="bi bi-check2"></i>
                            </button>
                          }
                          {!employee.isActive &&
                            <button onClick={() => { setStaffActivation(employee.id) }} type='button' className='btn btn-danger btn-sm'>
                              <i className="bi bi-x"></i>
                            </button>
                          }
                        </td>
                        <td>
                          <button
                            onClick={() => editItem(employee.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(employee)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
    setPasswordError("");
    setPhoneNumberError("");
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const phoneNumberBlur = (e) => {
    const phoneNumber = e.target.value;
    if (!methods.validatePhoneNumber(phoneNumber)) {
      setPhoneNumberError("شماره تلفن وارد شده صحیح نیست.");
    } else {
      setPhoneNumberError("");
    }
  };

  const passwordBlur = (e) => {
    const password = e.target.value;
    if (password.length < 6) {
      setPasswordError("رمز وارد شده باید حداقل ۶ کاراکتر داشته باشد.");
    } else {
      setPasswordError("");
    }
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش کارمند</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3" autoComplete="off">
                <div className="col-md-4">
                  <label htmlFor="firstname" className="form-label required-label">نام</label>
                  <input type="text" className="form-control" id="firstname" name="firstname"
                    value={formModel.firstname}
                    onChange={(e) => { setFormModel({ ...formModel, firstname: e.target.value }) }}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="lastname" className="form-label required-label">نام خانوادگی</label>
                  <input type="text" className="form-control" id="lastname" name="lastname"
                    value={formModel.lastname}
                    onChange={(e) => { setFormModel({ ...formModel, lastname: e.target.value }) }}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="phoneNumber" className="form-label required-label">موبایل</label>
                  <input type="text"
                    className={`form-control ${phoneNumberError ? "is-invalid" : ""}`}
                    id="phoneNumber"
                    value={formModel.phoneNumber}
                    onChange={(e) => { setFormModel({ ...formModel, phoneNumber: e.target.value }) }}
                    onBlur={phoneNumberBlur}
                  />
                  {phoneNumberError && (
                    <div className="invalid-feedback">{phoneNumberError}</div>
                  )}
                </div>
                <div className="col-md-4">
                  <label htmlFor="nCode" className="form-label required-label">کد ملی</label>
                  <input type="text" className="form-control" id="nCode" name="nCode"
                    value={formModel.nCode}
                    onChange={(e) => { setFormModel({ ...formModel, nCode: e.target.value }) }}
                  />
                </div>
                <div className="col-md-4">
                  <label htmlFor="employeetype" className="form-label required-label">سمت شغلی</label>
                  <select
                    id="saleUnit"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.employeeType}
                    onChange={(e) => {
                      formModel.employeeType = parseInt(e.target.value);
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {employeeTypes.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4">
                  <label htmlFor="city" className="form-label">
                    جنسیت
                  </label>
                  <select
                    id="city"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.gender}
                    onChange={(e) => {
                      formModel.gender = e.target.value;
                      setFormModel({ ...formModel });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    <option value={1}>مرد</option>
                    <option value={2}>زن</option>
                  </select>
                </div>
                <div className="col-md-6 my-4">
                  <label htmlFor="password" className="form-label required-label">رمز عبور(حداقل ۶ کاراکتر)</label>
                  <input type="text" className={`form-control ${passwordError ? "is-invalid" : ""}`}
                    id="password" name="password"
                    value={formModel.password}
                    onChange={(e) => { setFormModel({ ...formModel, password: e.target.value }) }}
                    autoComplete="new-password"
                    onBlur={passwordBlur}
                  />
                  {passwordError && (
                    <div className="invalid-feedback">{passwordError}</div>
                  )}
                </div>
                <div className='col-md-12 my-4'>
                  <label htmlFor="fileUpload" className="form-label">انتخاب تصویر <br></br>
                    <span style={{ fontSize: "14px" }}>
                      (اندازه استاندارد  400×400  و حداکثر حجم 600kb است.)
                    </span>
                  </label>
                  <div
                    className='uploadfile'
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const file = e.dataTransfer.files[0];
                      changeImage(file);
                    }}
                  >
                    {!isImageUploading &&
                      <label htmlFor="imagefileInput" >
                        {formModel.avatar ? formModel.avatar : 'تصویر را بکشید اینجا بیاندازید'}
                        <input
                          type="file"
                          id="imagefileInput"
                          style={{ display: 'none' }}
                          name="imagefileInput"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) => changeImage(e.target.files[0])}
                        />
                      </label>
                    }
                    {isImageUploading && (
                      <div className="uploadfileloading form-control border-0">
                        <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"> در حال بارگذاری ... </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-12 my-4">
                  <label htmlFor="address" className="form-label">آدرس</label>
                  <textarea type="text" className="form-control" id="address" name="address" rows={3}
                    value={formModel.address || ""}
                    onChange={(e) => { setFormModel({ ...formModel, address: e.target.value }) }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeModal}
              >
                انصراف
              </button>
              {isImageUploading ?
                <button type="submit" className="btn custome-btn btn-purple w-50" disabled>ثبت وذخیره</button>
                :
                <button type="submit" className="btn custome-btn btn-purple w-50 "
                  onClick={() => { createNewItem() }}
                >ثبت وذخیره</button>
              }
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'کارمند'}
        />
      }
    </>
  );
}

export default Employee;